/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-09-19 21:25:38
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-09-19 22:25:56
 */
export const privacy =
    `
<span class="tip">【特别提示】请您仔细阅读我们的《快转平台隐私政策》并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可及时与我们联系（联系方式以隐私政策里约定的为准）。如您不同意协议中的任何条款，您应立即停止访问快转平台。</span>
<h2>快转平台隐私政策</h2>
<span class="tip">快转平台（以下亦称"我们"）深知个人信息对您的重要性，我们尊重并保护所有使用快转平台平台服务的用户的个人信息，并会尽全力保护您的个人信息安全可靠。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请在使用我们的产品（或服务）前，仔细阅读并了解本《快转平台隐私政策》（下称"本隐私政策"）。</span>
<span class="tip">如您对本隐私政策有任何疑问或您在使用我们提供的服务时个人信息受到了侵扰，您可以发送邮件至biz@soonboom.com咨询，我们设立了个人信息保护专职部门，将尽快给予您答复;您亦可以通过快转平台联系客服与我们及时取得联系，以便我们能够及时解决您的困惑。</span>


<h1 align="center">目录</h1>
<h3>一、我们处理个人信息的总原则</h3>
<h3>二、本隐私政策的适用范围</h3>
<h3>三、我们如何收集和使用您的个人信息</h3>
<h3>四、我们如何共享、转让、公开披露您的个人信息</h3>
<h3>五、我们如何存储及保护您的个人信息</h3>
<h3>六、注销账户</h3>
<h3>七、我们如何处理未成年人的个人信息</h3>
<h3>八、本隐私政策的更新和通知</h3>
<h3>九、如何联系我们</h3>
<h3>十、争议解决</h3>


<h2>一、我们处理个人信息的总原则</h2>

<p>通常，我们会基于本隐私政策提示的功能收集您的个人信息。某些情况下，如果涉及其他信息的收集我们会单独向您出示个人信息保护说明条款。在处理您的个人信息方面，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息∶权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则。</p>


<h2>二、本隐私政策的适用范围</h2>

<p>本隐私政策适用于您使用快转平台。快转平台的运营主体为武汉千城万铺网络科技有限公司</p>


<h2>三、我们如何收集和使用您的个人信息</h2>

<p>本隐私政策所涉及的个人信息或个人敏感信息所包含的内容出自于《个人信息安全规范》。我们将在本条第（一）、第（二）款中详细论述我们基于以下所述功能，收集和使用您的个人信息的类型和目的。
个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，如姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。
个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策涉及到的个人敏感信息我们将加粗并加下划线的方式提示您注意阅读。在您向快转平台提供任何属于敏感信息的个人信息前，请您清楚考虑该等提供是恰当的并且同意您的个人敏感信息可按本隐私政策所述的目的和方式进行处理。我们会在得到您的同意后收集和使用您的敏感信息以实现与快转平台业务相关的功能，并允许您对这些敏感信息的收集与使用做出不同意的选择，但是拒绝使用这些信息会影响您使用相关功能。
原则上，快转平台仅会出于本隐私政策所述的以下目的，收集和使用您的个人信息。快转平台是综合类的信息发布平台，所涉场景较多，如果超过以下目的收集和使用您的个人信息时我们会单独向您提示并征得您的同意
<br/>（一）帮助您成为我们的注册/登录用户您通过第三方授权登录为快转平台的用户您使用第三方帐号（微信）登录快转平台时，可选择授权快转平台在符合相关法律法规要求的前提下读取并获得您在该第三方平台上登记、公布、记录的公开信息（包括昵称、头像、联系方式）。快转平台需要您授权从第三方获取上述信息是为了记住您作为快转平台用户的登录身份，以向您提供更优质的产品和/或服务。我们仅会在您的授权同意的范围内收集并使用您的个人信息。
您提供的上述信息，将在您使用快转平台服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。
上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。
<br/>（二）向您提供我们的产品或服务
<br/>1、信息发布功能<br/>
快转平台平台最主要的功能就是信息发布功能，当您使用发布功能时，我们会收集您的个人信息，包括姓名、联系方式、个人信息资料、地理位置、用户相册、邮箱、地址信息。此类信息为您自己主动填写的信息，收集是为了方便您能成功发布信息，可以更快捷的与您发布的内容进行匹配。
您在发布房源信息时，可能需提供您的联系方式（便于买家及时有效联系您）、价格信息、姓名信息，如您选择的房源图片来源于您的相册，我们用到您的相册，收集上述信息仅为了您能更清晰快捷的展示您的推广信息。为了更好的推广您的信息或增加您发布信息的曝光量，您授权快转平台将您在快转平台的昵称、头像在快转平台合作的第三方平台展示。
<br/>2、搜索功能<br/>
当使用快转平台提供的搜索功能时，我们会收集您查询的关键字信息以及您在使用快转平台服务时所浏览或要求的其他信息和内容详情。为了给您带来更便捷的搜索服务并不断完善快转平台产品和/或服务。该等关键词信息通常无法单独识别您的个人身份，不属于您的个人信息，不在本隐私政策的限制范围内。只有当您的搜索关键词信息与您的其他信息有联结并可识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。
<br/>3、匹配功能<br/>
为提高转店、求购效率，快转平台会根据双方发布的信息进行匹配，并将匹配到的头像、昵称、电话、店铺详情对被匹配用户进行公布，被匹配用户可以点击您的头像、昵称、电话、店铺详情来查询您发布的有关信息。
<br/>4、浏览记录<br/>
您浏览过的信息会被提示给被浏览的用户，被浏览用户可以看到您的头像、昵称、电话、店铺详情对被浏览用户进行公布，被浏览用户可以点击您的头像、昵称、电话、店铺详情来查询您发布的有关信息。
<br/>5、客户服务<br/>
当您向快转平台发布信息、申诉或进行咨询时，为了方便与您联系或帮助您解决问题，我们可能需要您提供姓名、手机号码、电子邮件信息。如您拒绝提供上述信息，可能部分功能无法使用，同时无法向您及时反馈申诉或咨询结果。
<br/>6、定向推送<br/>
我们会基于收集的信息，对您的偏好、习惯、位置作特征分析和用户画像，以便为您提供更适合的定制化服务，例如向您展现或推荐相关程度更高（而非普遍推送）的订阅信息、信息流或者广告/推广信息结果。为此，我们需要收集的信息包括您的设备信息、日志信息、浏览记录。
<br/>7、支付功能<br/>
您可在快转平台进行部分服务支付购买。在您使用该服务的过程中可能会需要进行支付，在支付过程中，我们可能会收集您的第三方支付帐号。
<br/>8、推广服务<br/>
您在快转平台平台购买增值服务支付费用时，我们会记录您的支付方式，以完成支付服务。9、客户服务及争议处理
为向您提供客户服务，我们会记录您提供的联系方式和通信/通话记录和内容，用于与您联系和帮助您解决问题，或记录相关问题的处理方案及结果。
<br/>10、为您提供更个性化的服务<br/>
1）基于位置信息的个性化推荐功能∶我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点。如房产频道，会自动为您推荐您所在区域的房源或楼盘信息。
<br/>2）基于摄像头（相机）的服务功能∶您可以使用这个功能完成视频拍摄、拍照、推广信息的编辑发布，或通过该功能完成推广信息的查阅。
<br/>3）基于图片上传的功能∶您可以在快转平台上传您的照片来实现您想要发布的推广信息的编辑发布。4）基于语音技术的附加功能∶您可以直接使用麦克风来发布信息或与快转平台的其他用户进行非实时的互动。
上述功能基于您对第三方（微信）的授权产生，如取消授权需在对（第三方）微信授权中取消。
在不透露单个用户隐私资料的前提下，快转平台及其关联公司有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。快转平台可能会对网络服务使用情况进行统计。同时，快转平台可能会与公众分享这些统计信息，以展示我们服务的整体使用趋势。这些统计信息不包含您的任何身份识别信息。
<br/>（三）征得授权同意的例外
<br/>根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息∶
1、与国家安全、国防安全直接相关的;
<br/>2、与公共安全、公共卫生、重大公共利益直接相关的;
<br/>3、与犯罪侦查、起诉、审判和判决执行等直接相关的;
<br/>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;
<br/>5、所收集的个人信息是您自行向社会公众公开的;
<br/>6、从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道;
<br/>7、根据您的要求签订和履行合同所必需的;
<br/>8、法律法规规定的其他情形。
您知悉并认可∶快转平台通过广告或其他方式向您提供链接，使您可以接入第三方服务或网站。您使用该等第三方的服务时，须受该第三方的服务条款及隐私政策约束，快转平台提示您需要仔细阅读其政策。本协议仅适用于快转平台提供的服务器所收集的信息，并不适用于第三方提供的服务或第三方的信息使用的规则，快转平台对第三方使用由您自行提供的信息不承担责任。</p>


<h2>四、我们如何共享、转让、公开披露您的个人信息</h2>

<p>（一）共享
我们不会与快转平台以外的任何公司、组织和个人分享您的个人信息，但以下情况除外∶
<br/>1、在获得明确同意的情况下共享∶获得您的明确同意后，我们会与其他方共享您的个人信息。
<br/>2、根据法律法规的规定和行政、司法机构的要求∶我们可能会根据法律法规规定，或按政府主管部门的强制性要求，向上述监管部门共享您的个人信息。
<br/>3、与我们的关联公司共享∶您的个人信息可能会与快转平台的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
关联公司指快转平台平台运营主体直接或间接控制的法人实体及其分支机构，与快转平台平台运营主体直接或间接共同受控于同一实际控制人的法人实体及其分支机构;控制、受控指∶通过协议或股权控制或受控。
<br/>4、与授权合作伙伴共享∶仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，您在使用我们招聘频道服务创建简历后，您主动将简历投递给招聘方时，我们必须与该招聘方共享您的简历信息才能让招聘方看到您的简历信息与您沟通面试。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
目前，我们的授权合作伙伴包括以下2大类型∶
<br/>1）广告、分析服务类的授权合作伙伴。我们不会将您的个人信息与提供广告、咨询类服务商与关联公司共享，除非您主动授权我们提供。但我们可能会将经处理无法识别您的身份且接收方无法复原的信息，例如经匿名化处理的用户画像，与广告或咨询类服务商或广告主共享，以帮助其在不识别您个人的前提下，提升广告有效触达率，以及分析我们的产品和服务使用情况。
<br/>2）服务提供商和其他合作伙伴。您在使用我们的具体服务时，您自主填写的信息，我们将您填写的信息发送给您想要联系的服务提供商。
对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
<br/>5、以学术研究或公共利益为目的，且无害于您的重大利益;
<br/>6、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷;
<br/>7、只有共享您的信息，才能提供您需要的服务或处理您与他人的纠纷或争议。例如您在快转平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，快转平台会视情况向该用户提供其交易对方的联络方式必要信息，以促成交易的完成或纠纷的解决;
<br/>（二）转让
我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外∶
<br/>1、在获取明确同意的情况下转让∶获得您的明确同意后，我们会向其他方转让您的个人信息;
<br/>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
<br/>（三）公开披露
我们仅会在以下情况下，公开披露您的个人信息∶
<br/>1、获得您明确同意后;
<br/>2、基于法律的披露∶在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会对上述监管部门披露您的个人信息。
我们知晓对外共享、转让、公开披露个人信息所承担的相应法律责任。我们承诺按照本条款的要求共享、转让、公开披露您的个人信息，按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗、提示等形式征得您的同意或确认第三方已经征得您的同意。
因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过本隐私政策文首处提供的联系方式操作。</p>


<h2>五、我们如何存储及保护您的个人信息</h2>

<p>（一）信息存储
<br/>快转平台收集的有关您的信息和资料将保存在快转平台及（或）其关联公司的服务器上，这些信息和资料全部储存在中国境内。目前，快转平台的产品和服务不会涉及到数据的跨境传输，如果我们的产品服务发生变更，涉及数据的跨境传输，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。
我们仅在您使用我们的服务期间和法律法规要求的最短时限内保留您的个人信息，对于超出期限的个人信息，我们会立即删除或做匿名化处理。
<br/>（二）信息保护
<br/>为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。
<br/>1、数据加密∶我们对于用户的用户名、手机号、注册邮箱、qq号进行加密存储，保证用户基本信息不会被恶意获取;
<br/>2、身份鉴别∶我们通过校验账号密码或者账号绑定手机验证码，进行用户身份合法性鉴别，防止非经授权的介入;
<br/>3、访问控制∶我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。快转平台用户在进行身份鉴别后，才能查询并管理用户信息和资源，未经过身份鉴别，不能管理用户资源;</p>


<h2>六、注销账户</h2>

<p>您可以在我们的产品或服务中直接申请注销账户。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。
注销账户的方式，联系客服</p>


<h2>七、我们如何处理未成年人的个人信息</h2>

<p>1、快转平台主要为转店服务类平台，我们的服务主要面向成年人（原则上18周岁以上为成年人，16周岁以上且以自己的劳动收入为主要生活来源的我们亦视为成年人）。若您是未成年人，在使用我们的产品和/或服务前，您应在监护人的陪同下阅读本隐私政策，并应确保已征得您的监护人同意后使用我们的服务并向我们提供您的信息。我们会根据国家相关法律法规的规定着重保护未成年人的个人信息。
<br/>2、如您的监护人不同意您按照本隐私政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们。
<br/>3、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
<br/>4、若您是未成年人的监护人，当您对您所监护的未成年人使用我们的服务或其向我们提供的用户信息有任何疑问时，请您及时与我们联系。我们将根据国家相关法律法规及本隐私政策的规定保护未成年人用户信息的保密性及安全性。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>


<h2>八、本隐私政策的更新和通知</h2>

<p>我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本隐私政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过平台进行公示或者通过公众号发生信息，说明隐私政策的具体变更内容）。
本隐私政策所指的重大变更包括但不限于∶
<br/>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等;
<br/>2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等;
<br/>3、个人信息共享、转让或公开披露的主要对象发生变化;
<br/>4、您参与个人信息处理方面的权利及其行使方式发生重大变化;
<br/>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时;
<br/>6、个人信息安全影响评估报告表明存在高风险时。</p>


<h2>九、如何联系我们</h2>

<p>如您对本隐私政策有任何疑问或您在使用我们提供的服务时个人信息受到了侵扰，您可以通过qcwp123@163.com邮箱与我们联系、通过快转平台联系客服与我们联系，我们设立了个人信息保护专职部门，将尽快给予您答复。一般情况下，我们将在十五天内（国家法定节假日顺延）回复。</p>


<h2>十、争议解决</h2>

<p>因本隐私政策以及我们处理您个人信息事宜引起的任何争议，由武汉千城万铺网络科技有限公司住所地法院管辖。</p>
<p align="right" class="bottom">版本更新日期∶2020年9月 20日</p>
<p align="right" class="bottom">版本生效日期∶2020年9月 20日</p>
`

export const promote =
    `
<header>快转推广服务协议</header>

<h4>【重要须知】
为使用快转平台推广服务（以下简称“本服务”），您应当阅读并遵守《快转推广服务协议》（以下简称“本协议”）、《用户使用协议》、《隐私协议》以及专项规定等。
请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。如果您不同意本协议或无法理解本协议全部或部分条款，请立即停止相关操作。
除非您已阅读并接受本协议所有条款，否则您无权使用本服务。如果您继续进行信息填写或进行本服务的购买，则视为您对本协议下所有内容和条款均已明确知悉，并且完全同意。
如果您未满18周岁，请立即停止开通推广服务的相关操作。</h4>

<h5>⦁	一、【相关定义】</h5>
<h6>1.1 本协议：指您与武汉千城万铺网络科技有限公司（以下简称“快转公司”）之间关于您使用快转平台的信息推广服务所订立的协议。
<br/>1.2 快转平台：指武汉千城万铺网络科技有限公司所拥有和经营的网络信息平台(www.o58.top)。关于用户注册和隐私保护条款，适用平台相关约定。
<br/>1.3 客户：指使用快转平台推广服务并享受服务权益的主体，以下简称“您”。
<br/>1.4 本服务：指快转公司依本协议约定向您提供的网络信息展示服务。
<br/>1.5 置顶：指特定信息在特定栏目的网络前端展现后，排名位于对应类别首位的展示方式。</h6>
<h5>⦁	二、【关于本服务】</h5>
<h6>2.1 快转公司向您提供的网络信息展示服务，具体包括：
<br/>1)	信息发布：快转公司将根据您提所交的房产供应信息内容，将其发布在快转平台特定城市（与不动产所在地对应）栏目下的特定分类。
<br/>2)	信息展现：快转平台对上述信息提供自发布之日起为期30天的展示服务。
<br/>3)	信息置顶：服务期（即展示期）内，快转提供1次置顶服务。
<br/>2.2 服务期限：30天，自信息发布之日起算。
<br/>2.3 服务费用：本服务为收费服务，您应当在提交信息后，按照平台所显示的金额向快转公司足额支付服务费用，方可享受相关权利。
<br/>2.4 服务保证：快转公司向客户提供“不成功全额退款”的承诺。服务到期后，满足条件的客户可向快转平台提交必要资料主张退款。</h6>
<h5>⦁	三、【您的权利与义务】</h5>
<h6>3.1 您应当向快转平台提供真实有效的信息，该信息的范围包括但不限于：
<br/>（1）身份信息及联系电话；
<br/>（2）待发布的房产供应信息；
<br/>（3）合法拥有房产相关权利的法律文书；
<br/>（4）所推广的房产供应信息未成交的证明文件。
<br/>3.2 本协议成立前，您向快转公司不可撤销地承诺和保证，对所提交的全部信息的真实性、有效性和合法性负责。
<br/>3.3 您在使用快转平台服务（包括但不限于本服务）时，应当严格遵守服务协议条款和平台相关规则，不得利用相关服务从事包括但不限于下列行为在内的活动：
<br/>（1）发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；
<br/>（2）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；
<br/>（3）虚构事实、隐瞒真相以误导、欺骗他人；
<br/>（4）发表、传送、传播广告信息及垃圾信息；
<br/>（5）从事其他违反法律法规、政策及公序良俗、社会公德等的行为。
<br/>3.4 您应当按照本协议约定，在享受推广服务前足额向快转公司支付服务费用，此后方可享有本服务所具有的相关权利。
<br/>3.5 您清楚并理解，置顶服务受新发布的推广信息量的影响，您所发布的推广信息在服务期限内并不会必然处于栏目首位。
<br/>3.6 您在接受本协议后，对后续的服务过程有质疑的，应当提供相关凭据和依据通过客服提出异议；对后续涉嫌侵权或违规的行为，应当及时进行举证。
<br/><span style="font-weight: 800;
    background: #ff5252;
    color: #fff;">3.7 服务期限届满，推广信息所对应的房产未成交的，您应当在推广期限届满次日起3天内，向客服提出退款申请。逾期未提出的，视为已经成交，此后无权对该次服务主张退款。</span>
<br/><span style="font-weight: 800;
    background: #ff5252;
    color: #fff;">3.8 符合退款申请时，您应当一次性提交下列全部资料，交由快转公司审核：
<br/>（1）所推广房产的房产证原件照片；
<br/>（2）房产所有人的身份证照片（原件正反两面）和联系方式；
<br/>（3）房产所有人出具的房产未成交的书面承诺；
<br/>（4）信息发布人的身份证照片（原件正反两面）和联系方式；
<br/>（5）信息发布人拥有房产使用或处分权的法律文书（如租房合同或房产所有人授权书）；
<br/>（6）其他具有公信力的官方机构提供的相关证明。
注：当信息发布人与房产所有人为同一人时，无需提供第（4）（5）项。</span>
<br/>3.9 您承诺并保证，您与第三人因房产交易而产生的纠纷，由当事双方自行解决，与快转平台无关。
<br/>3.10 您清楚并知晓，快转公司在服务期内可能会对本协议及其他相关协议的条款和平台规则进行修改。此情形发生时，您认可并同意执行最新版的协议和规则。</h6>
<h5>⦁	四、【快转的权利与义务】</h5>
<h6>4.1 快转平台有权按照本协议、其他相关协议和平台规则，对客户的行为进行监督管理。快转公司有权根据法律、法规或公司经营要求，随时修改本协议的有关条款，快转平台将通过适当的方式对修改后的内容在平台上予以公示。
<br/>4.2 快转公司应当按照本协议的约定，对支付服务费用的客户及时提供推广服务，在收费后3天内完成信息发布。
<br/>4.3 除本协议的免责情形外，快转平台应当履行必要职责，保证服务期内客户推广信息的展现时长。
<br/>4.4 快转公司应当在客户推广信息发布后3日内进行置顶操作，但并不保证服务期限内必然处于首位。
<br/>4.5 因第三人对快转平台发布的推广信息的真实性、有效性、合法性提出异议，信息发布人应当及时提供辅助证明材料。当下列情形出现时，快转平台有权对该推广信息下线、删除或对信息发布人封禁账号的处理。
<br/>（1）信息发布人未及时提供证明材料；
<br/>（2）证明材料不能证明其为合法权利人或有权发布该信息的；
<br/>（3）推广信息确实存在违法情形；
<br/>（4）推广内容涉嫌侵害第三人合法权益的。
<br/>4.6 接到退款申请后，快转平台应当在3天内作出审核并给出答复。审核通过的，应当在答复后3天内完成退款；审核未通过的，应当注明原由。</h6>

<h5>⦁	五、【违约与免责】</h5>
<h6>5.1 快转平台依照法律规定履行基础保障义务，但对于下述原因导致的协议履行障碍、履行瑕疵、履行延后或履行内容变更等情形，快转公司并不承担任何违约责任：
<br/>（1）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
<br/>（2）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；
<br/>（3）在平台已尽管理责任的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
<br/>5.2 由于客户违反诚实信用义务或未严格遵守平台规定，最终导致信息被下线、删除或账号被禁用的，因此造成的损失由信息发布人（即付款人）承担，且其后续不得以任何理由向快转提出任何退款或赔偿请求。
<br/>5.3 客户与第三人因房产交易而产生的纠纷，由客户自行解决，快转公司免责。由此造成快转公司牵涉其中且造成经济损失的，客户对快转的损失负有赔偿责任。
<br/>5.4 快转平台在接到退款申请后，在合理期限内未给予回复的，应当向客户足额退款。</h6>
<h5>⦁	六、【协议的法律管辖和其他】</h5>
<h6>6.1 您与快转公司就本协议的订立、执行和解释及争议的解决，均应适用中华人民共和国（不包括港澳台地区）的法律。
<br/>6.2 双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成的，任何一方均应向武汉千城万铺网络科技有限公司所在地人民法院提起诉讼。
<br/>6.3 您向快转平台支付本协议服务价款时，本协议则直接成立，并立即生效。
<br/>6.4 本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的，且不影响任何其余条款的有效性和可执行性。</h6>
`

export const use =
    `
<h1 align="center">欢迎您使用快转平台的服务!</h1>
<span class="tip">为使用快转平台的服务，您应当阅读并遵守《快转平台使用协议》和《快转平台隐私政策》。本协议是用户与快转平台之间的法律协议，是用户注册快转平台账号和/或使用快转平台服务时使用的通用条款。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款。限制、免责条款可能以黑体加粗或加下划线的形式提示您重点注意。您不应当以快转平台未对本协议以合理方式提醒用户注意或未根据用户要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。除非您已阅读并接受本协议所有条款，否则您无权使用快转平台提供的服务。您使用快转平台的服务即视为您已阅读并同意上述协议的约束。</span>
<h2>一、定义</h2>
<p>1.1快转平台，是指武汉千城万铺网络科技公司运营的快转平台网站（www.o58.top）。<br/>
1.2用户，包含注册用户和非注册用户，以下亦称为“您”<br/>
1.3注册用户是指通过快转平台完成全部注册程序后，使用快转平台服务的用户。<br/>
1.4非注册用户是指未进行注册、直接登进入快转平台直接或间接地使用快转平台服务的用户。<br/>
1.5协议方，本协议中协议双方合称"协议方"。武汉千城万铺网络科技有限公司及其相关服务可能存在的运营关联单位、快转平台在协议中统称为"快转平台"。</p>
<h2>二、协议的效力</h2>
<p>2.1在您按照页面提示填写输入手机号码时、阅读并同意本协议或以其他快转平台允许的方式实际使用快转平台服务时，您即受本协议的约束。
<br/>2.2本协议内容包括本协议正文、《快转平台隐私政策》，且您在使用快转平台某一特定服务时，该服务可能会另有单独的协议、相关业务规则（如《快转平台服务协议》）等（以下统称为"规则"）。所有快转平台已经发布的或将来可能发布的规则为本协议不可分割的组成部分，与本协议具有同等法律效力。除另行明确声明外，任何快转平台及其关联公司提供的服务（以下称为"快转平台服务"）均受本协议约束。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用快转平台服务;如您继续访问和使闪快转平台服务，即视为您已确知并完全同意本协议各项内容
<br/>2.3快转平台有权根据国家法律法规的更新、产品和服务规则的调整需要不时地制订、修改本协议及/或各类规则，并提前在平台进行公示。如您继续使用快转平台服务的，即表示您接受经修订的协议和规则。如发生有关争议时，以快转平台最新的相关协议和规则为准。</p>
<h2>三、注册</h2>
<p>3.1您确认，在您完成注册程序或以其他快转平台允许的方式实际使用快转平台服务时，您应当是具备相应民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的家长或法定监护人（以下统称"监护人"）应承担因此而导致的一切后果，且快转有权注销您的账户，并向您及您的监护人索偿。
<br/>3.2快转平台非常重视对青少年个人信息搜集和使用的安全性的保护。快转平台建议，任何未满18周岁的未成年人参加网上活动应事先取得其监护人可经查证的同意并遵守《全国青少年网络文明公约》。监护人应承担未成年人网络活动风险及保护未成年人相关网络隐私的首要责任。
<br/>3.3在注册使用平台服务时，您填写的手机号应当填写本人或者经他人授权的真实合法的手机号码，否则您将承担因此而造成的一切法律责任。
<br/>3.4在您签署本协议，完成发布信息时，平台申请获取您的发布信息填写的号。您应对您的用户账户，以及对通过您的账户实施的行为负责;因此所衍生的任何损失或损害，快转平台无法也不承担任何责任，除非有法律规定或行政司法机关的指令，且征得快转平台的同意，否则您的用户账户不得以任何方式转让、借用、赠与、继承（与账户相关的财产权益除外）<或>在第三方平台上进行展示或售卖。否则，由此给您（或快转平台、任何第三方）造成的一切损失，概由您自行承担（或者负责赔偿）
<br/>3.5如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即以有效方式通知快转平台，要快转平台暂停相关服务。您理解快转平台对您的请求采取行动需要合理时间，快转平台对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。
<br/>3.6您在注册帐号或使用快转平台服务的过程中，应提供合法、真实、准确的个人资料，您填写的个人资料有变动的，应及时进行更新。如果因您提供的个人资料不合法、不真实、不准确的，您需承担因此引起的相应责任及后果，并且快转平台保留终止您使用快转平台各项服务的权利。
<br/>3.7在您根据页面提示同意本协议，发布信息后，即可成为快转平台注册用户。对于您主动提交的相关信息，您快转平台运营者及关联服务提供方委托的第三方通过合法渠道（包括但不限于征信机构等）了解、咨询、审查您的个人市场交易风险的真实情况，并据此判断您的风险状况。
<br/>3.8您了解并同意，发布信息后，即视为您同意闪快平台及/或其关联公司可以通过拨打电话、发送短信或者电子邮件、微信公众号信息等方式向您注册时填写的手机号码、电子邮箱、关注的微信公众号信息提示等发送、告知相应的产品服务广告信息、促销优惠等营销信息;您如果不同意接收相关信息，您可以通过相应的退订功能或相关提示进行退订、取消公众号关注等。
</p>
<h2>四、用户帐号及安全</h2>
<p>4.1在完成发布信息时，平台会根据用户授权将用户的手机号作为平台账号。用户有义务保证帐号的安全。用户应对利用该帐号所进行的一切活动负全部责任，包括任何经由快转平台上载、张贴、发送电子邮件或任何其它方式传送的资讯、资料、文字、整件、音乐、音讯、照片、图形、视讯、信息或其它资料，无论系公开还是私下传送，均由内容提供者承担责任。
<br/>4.2用户的帐号遭到未获授权的使用，或者发生其它任何安全问题时，用户应立即通知快转平台。由于用户使用不当或者其他非因快转平台导致的帐号泄漏，进而导致其资料、信息泄漏的，由用户承担其不利后果。
<br/>4.3用户不得将账号主动告知第三方或提供给第三方进行使用，例如提供给第三方进行代为购买快转平台服务等。如因此造成用户隐私泄露或快转平台损失的，用户应当承担相应的责任
</p>
<h2>五、服务说明</h2>
<p>5.1快转平台是提供互联网信息发布空间及技术服务的互联网平台。对于用户通过快转平台提供的服务传送的内容，快转平台会尽合理努力按照国家有关规定严格申查，但无法完全控制经由软件/网站服务传送的内容，不保证内容的正确性、及时性、完整性或品质，不对内容负责。
<br/>5.2快转平台在提供网络服务时，可能会对部分网络服务收取一定的费用，在此情况下，会在相关页面上做明确的提示。如用户拒绝支付该等费用，则不能使用相关的网络服务。付费业务将在本注册条款的基础上另行规定服务条款，以规范付费业务的内容和双方的权利义务，用户应认真阅速，如用户购买付费业务，则视为接受付费业务的服务条款。
<br/>5.3用户购买付费服务的，快转平台按照约定提供相关服务，但不对服务效果提供保证。
<br/>5.4对于利用快转平台进行非法活动，或其言行（无论线上或者线下的）背离闪快转平台服务用户目的的，快转平台将严肃处理，包括将其列入黑名单、将其被投诉的情形公之于众、删除用户帐号等处罚措施，给快转平台造成经济或者名誉等任何损失的，快转平台将追究其法律责任。
<br/>5.5快转平台有权向其用户发送广告信，或为活动等目的，向其用户发送电子邮件、短信、电话通知、公众号信息提示。除系统通知或重要信息外，用户可以通过快转平台提供的方式选择不接收上述信息
<br/>5.7为提高快转平台用户转让、出租、转租和购买、承租的成功率和效率，快转平台公司可能会将快转平台用户的信息公开展示范围，扩大至我们运营的其他平台，因此，您在使用快转平台时，可能还会收到来自快转平台公司未来运营的其他平台上的注册用户向您开聊、交换微信、联系电话等相关讯息。您可通过《快转平台隐私政策》了解我们在此期间如何保障您的个人信息的安全。
<h2>六、用户权利</h2>
<p>用户对于自己的个人信息享有以下权利∶
<br/>1.随时查询及请求阅览，但因极少数特殊情况（如被平台加入黑名单等）无法查询及提供阅览的除外;
<br/>2.随时请求补充或更正，但因极少数特殊情况（如平台或有关机关为司法程序保全证据等）无法补充或更正的除外;
<br/>3.随时请求注销侉子平台账号。您注销成功后，我们将根据法律法规的要求尽快删除您的个人信息或作匿名化处理。
</p>
<h2>七、快转平台服务使用规范</h2>
<p>7.1通过快转平台，您可以按照快转的规则发布各种商铺、厂房、仓库、房屋、办公室（包括办公楼）等房产转让、租赁、求租、购买等信息。但所发布之信息不得含有如下内容
（1）反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律、行政法规实施的
（2）煽动危害国家安全、泄露国家秘密、颠覆国家政权，推翻社会主义制度的;
（3）煽动分裂国家、破坏国家统一、损害国家荣誉和民族利益的;
（4）煽动民族仇恨、民族歧视，破坏民族团结的;
（5）捏造或者歪曲事实，散布谣言，扰乱社会秩序的
（6）进行政治宣传或破坏国家宗教政策、宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的
（7）公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的;
（8）损害国家机关信誉的;
（9）其他违反宪法和法律法规的;
<br/>7.2在接受快转平台服务的过程中，您不得从事下列行为∶
（1）发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，包含病毒、木马、定时炸弹等可能对快转平台系统造成伤害或影响其稳定性的内容制造虚假身份以误导、欺骗他人;
（2）传送或散布以其他方式实现传送的含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，作为举例（但不限于此）∶包括版权或商标法（或隐私权或公开权），除非用户拥有或控制着相应的权利或已得到所有必要的认可
（3）使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用本"软件"获得的图像或相片的资料或信息;
（4）进行危害计算机网络安全的行为，包括但不限于∶使用未经许可的数据或进入未经许可的服务器/帐号;未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息;未经许可，企图探查、扫描、测试本平台系统或网络的弱点或其它实施破坏网络安全的行为;企图干涉、破坏本平台系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为;伪造TCP/IP数据包名称或部分名称;
（5）修改或伪造软件作品运行中的指令、数据、数据包，增加、删减、变动软件的功能或运行效果，不得将用于上述用途的软件通过信息网络向公众传播或者运营
（6）在未经快转平台书面明确授权前提下，出售、出租、出借、散布、转移或转授权软件和服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益;
（7）违背快转平台页面公布之活动规则，包括但不限于发布虚假信息、作弊或通过其他手段进行虚假交易。
<br/>7.3您了解并同意，快转平台有权应政府部门（包括司法及行政部门）的要求，向其提供您在快转平台填写的注册信息和发布纪录等必要信息，且无须征得您的同意或提前通知于您。
<br/>7.4在快转平台上使用快转平台服务过程中，您承诺遵守以下约定∶
（1）在使用快转平台服务过程中实施的所有行为均遵守国家法律、法规等规范文件及快转平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保快转平台免于因此产生任何损失或增
（2）不发布国家禁止发布的信息（除非取得合法且足够的许可），不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息
（3）不使用快转平台上的任何数据作商业性利用，包括但不限于在未经快转平台事先书面同意的情况下，以复制、传播等任何方式使用快转平台网站上展示的资料。
（4）不使用任何装置、软件或例行程序干预或试图干预快转平台的正常运作或正在快转平台上进行的任何活动。您不得采取任何将导致不合理的庞大数据负载加诸快转平台网络设备的行动。
<br/>7.5您了解并同意∶
（1）您违反上述承诺时，快转平台有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知于您。
（2）根据相关法令的指定或者快转平台服务规则的判断，您的行为涉嫌违反法律法规的规定或违反本协议和/或规则的条款的，快转平台有权采取相应措施，包括但不限于直接屏蔽、删除侵权信息、降低您的信用值或直接停止提供服务。如因此使快转平台遭受损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿快转平台因此造成的损失及（或）发生的费用，包括合理的
（3）对于您在快转平台上实施的行为，包括您未在快转平台上实施但已经对快转平台及其用户产生影响的行为，快转平台有权单方认定您行为的性质及是否构成对本协议和/或规则的违反，并据此采取相应的处理措施。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据承担不利后果。
（4）对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保快转平台免于承担因此产生的损失或增加的费用。
</p>
<h2>八、责任范围及责任的限制</h2>
<p>8.1快转平台公司将尽力为用户提供提供安全、及时、准确、高质量的服务，但不保证一定能满足用户的要求和期望，也不保证服务不会中断，对服务的及时性、安全性、准确性都不作保证。除非另有约定，否则用户因无法使用快转平台服务，或使用服务未达到心理预期的，快转平台不承担责任。
<br/>8.2快转平台与平台不对推广服务效果承担任何保证责任，推广效果主要基无推广产品的质量及用户体验等因素，教快转平台无需对服务效果负责，服务效果亦不可作为影响本协议执行及各方履行合同义务的因素或理由。
<br/>8.3快转平台对用户在本平台上发布的相关信息的正确性、准确性、可靠性或其他方面不做保证
<br/>8.4对于快转平台提供的各种第三方广告信息、链接、资讯等（如有），快转平台不保证其内容的正确性、合法性或可靠性，相关责任由广告主承担;并且，对于用户经由快转平台服务与广告主进行联系或商业往来，完全属于用户和广告主之间的行为，与快转平台无关。对于前述商业往来所产生的任何损害或损失，快转平台不承担任何责任。
<br/>8.5对于用户上传的照片、资料、证件、视频、内容及图片等，快转平台已采用相关措施并已尽合理努力进行审核，但不保证其内容的正确性、及时性、合法性或可靠性，相关责任由上传上述内容的用户承
<br/>8.6用户应对快转平台上的其他用户发布的内容自行加以判断，并承担因使用内容而引起的所有风险，包括但不限于因对内容的正确性、及时性、完整性、实用性或真实性的依赖而产生的风险。快转平台公司无法且不会对因前述风险而导致的任何损失或损害承担责任。
<br/>8.7是否使用软件/网站服务下载或取得任何资料应由用户自行考虑并自负风险，因任何资料的下载而导致的用户电脑系统的任何损环或数据丢失等后果，快转平台不承担任何责任。
<br/>8.8对于快转平台公司在线上或线下策划、发起、组织或是承办的任何转店相关的活动（包括但不限于收取费用以及完全公益的活动），快转平台不对上述转店效果向用户作出任何保证或承诺，也不担保活动期间用户自身行为的合法性、合理性。由此产生的任何对于用户个人或者他人的人身或者是名誉以及其他损害，应由行为实施主体承担责任。
<br/>8.9对于用户的投诉，快转平台将尽合理努力进行核实和处理，但不保证一定能满足投诉者的要求。快转平台有权决定是否向公众或向被投诉者公开投诉内容。对于投诉内容侵犯用户隐私权、名誉权等合法权利的，所有法律责任由投诉者承担，与快转平台无关。
<br/>8.10快转平台与其他的在线使用的互联网平台一样，也会受到各种不良信息、网络安全和网络故障问题的困扰，包括但不限于∶
（1）其他用户可能会发布诈骗或虚假信息，或者发表有谩骂、诅咒、诋毁、攻击内容的，或者含有淫秽、色情、下流、反动、煽动民族仇恨等让人反感、厌恶的内容的非法言论;
（2）其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私权和/或其他合法权益的图片、照片、文字等资料;
（3）面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁
您充分了解并同意：上述的各种不良信息、网络安全和网络故障问题，并不是快转平台所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，概由您自行承担，快转平台无须向您承担任何责任。
<br/>8.11您同意，在发现本平台任何内容不符合法律规定，或不符合本用户协议规定的，您有义务及时通知快转平台。如果您发现您的个人信息被盗用、您的版权或者其他权利被侵害，请将此情况告知快转平台并同时提供如下信息和材料∶
（1）侵犯您权利的信息的网址，编号或其他可以找到该信息的细节;
（2）您是所述的版权或者其他权利的合法拥有者的权利证明;
（3）您的联系方式，包括联系人姓名，地址，电话号码和电子邮件;
（4）您的身份证复印件、营业执照等其他相关资料。
经审查得到证实的，我们将及时删除相关信息。我们仅接受邮寄、电子邮件或传真方式的书面侵权通知。情况紧急的，您可以通过客服电话先行告知，我们会视情况采取相应措施。
<br/>8.12您了解并同意，快转平台不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿∶
（1）使用或未能使用快转平台服务;
（2）第三方未经批准地使用您的账户或更改您的数据;
（3）通过快转平台服务购买或获取任何商品、样品、数据、信息等行为或替代行为产生的费用及损失;
（4）您对快转平台服务的误解;
（5）任何非因快转平台的原因而引起的与快转平台服务有关的其它损失。
<br/>8.13您同意在使用快转平台服务过程中显示快转平台自行或由第三方服务商向您发送的推广或宣传信息（包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。除法律法规明确规定外，您应自行对依该推广信息进行的交易负责，对用户因依该推广信息进行的交易或前述第三方服务商提供的内容而遭受的损失或损害，快转平台不承担任何责任。
<br/>8.14快转平台对下列不可抗力行为免责∶信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服
<br/>8.15您应当严格遵守本协议及快转平台发布的其他协议、活动规则，因您违反协议或规则的行为给第三方或快转平台与造成损失的，您应当承担全部责任。
<br/>8.16快转平台保留在中华人民共和国大陆地区法施行之法律允许的范围内独立决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
</p>
<h2>九、协议终止</h2>
<p>9.1您同意，快转平台基于平台服务的安全性，有权中止向您提供部分或全部快转平台服务，暂时冻结您的账户，待安全问题解决后及时恢复，并对中止、冻结及恢复的事实及时通知。9.2如您对本协议的修改有异议，或对快转平台的服务不满，可以行使如下权利∶
（1）停止使用快转平台的网络服务;
（2）通过客服等渠道告知快转平台停止对其服务。结束服务后，您使用快转平台服务的权利立即终业
在此情况下，快转平台没有义务传送任何未处理的信息或未完成的服务给您或任何无直接关系的第三方。
<br/>9.3您同意，您与快转平台的协议关系终止后，快转平台仍享有下列权利∶
（1）继续保存您未及时删除的注册信息及您使用快转平台服务期间发布的所有信息至法律规定的记录保存期满。
（2）您在使用快转平台服务期间存在违法行为或违反本协议和/或规则的行为的，快转平台仍可依据本协议向您主张权利、追究责任。
</p>
<h2>十、隐私权政策</h2>
<p>快转平台依法保护用户个人信息和隐私信息。有关隐私政策的内容，详见本协议的《隐私政策》。
部平台相关声明版权及其修改权、更新权和法律允许范围内的解释权均属快转平台所有。
</p>
<h2>十一、通知</h2>
<p>快转平台向其用户发出的通知，将采用系统消息、弹窗、电子邮件、微信公众号信息提醒或页面公告等形式。本用户协议及隐私政策的条款修改或其他事项变更时，快转平台可以以上述形式进行通知。
</p>
<h2>十二、法律适用、管辖与其他</h2>
<p>12.1本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律，如法律无相关规定的，则应参照通用国际商业惯例和（或）行业惯例。
<br/>12.2本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性
<br/>12.3因本协议产生之争议、纠纷，应由快转平台与您友好协商解决;协商不成的，应依照中华人民共和国法律予以处理，并以武汉市东湖高新技术开发区人民法院为第一审管辖法院，按照中华人民共和国法律，因级别管辖的规定，汉市东湖高新技术开发区人民法院无权管辖的，以其上级法院作为第一审管辖法院。
为维护网民和相关权利人利益，快转平台为用户及相关权利人提供了便捷的线上投诉建议渠道（查找方式∶我的、监督投诉）。但因平台用户较多，平台会根据用户投诉时间先后顺序进行处理，可能会需要合理的时间，望能耐心等待，特此告知。
</p>
`
